module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



// WEBPACK FOOTER //
// ./node_modules/es-abstract/helpers/sign.js